import Event from "../Event"

export default class Notification extends Event {}
